import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Input from '../common/Input';
import useInput from '../../hooks/useInput';
import searchIcom from '../../images/icons/dark-search.svg';
import forProfitIcon from '../../images/icons/icon-industry-for-profit.svg';
import forNonProfitIcon from '../../images/icons/icon-industry-non-profit.svg';

import style from './Home.module.css';

const Home = React.memo(() => {
  const query = useInput('');

  useEffect(() => {
    document.title = 'HUB Small Business Management Liability';
  }, []);

  return (
    <div className={style.main}>
      <form method="get" action="/clients" className={style.search}>
        <div className={`form-group ${style.searchGroup}`}>
          <Input
            name="q"
            id="q"
            {...query}
            autocomplete="off"
            placeholder="Search by Name, Client ID, Client Code, Phone #, or Policy #"
            styles={style.searchInput}
            data-testid="home-page-search-input"
          />
          <button type="submit" className={style.searchBtn}>
            <img alt="search" src={searchIcom} />
          </button>
        </div>
      </form>
      <h1 className={style.h1} data-testid="home-page-heading-label">
        HUB Small Business Management Liability
      </h1>
      <h2 className={style.h2}>Start a new application</h2>
      <div className={style.startApp}>
        <Link to="start?forProfit=true" data-testid="home-page-for-profit-link">
          <img alt="start application" src={forProfitIcon} />
          <span className={style.startAppText}>For Profit</span>
        </Link>
        <Link
          to="start?forProfit=false"
          data-testid="home-page-not-for-profit-link"
        >
          <img alt="start application" src={forNonProfitIcon} />
          <span className={style.startAppText}>Not for Profit</span>
        </Link>
      </div>
    </div>
  );
});

export default Home;
